import {
  ListWorkOrderItemResult,
  WorkOrderItemOrigin,
  WorkOrderItemStatus,
  WorkOrderItemType,
} from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';

const workorderItems: ListWorkOrderItemResult = {
  workOrderComplementId: 0,
  totalDiscountPart: 0,
  partTotal: 0,
  totalDiscountService: 0,
  serviceTotal: 100,
  total: 100,
  nextToken: 0,
  data: [
    {
      id: 1,
      itemId: 1,
      type: WorkOrderItemType.Service,
      manufacturingCode: '',
      description: 'Turbo',
      quantity: 1,
      unitPrice: 100,
      unitCost: 0,
      discount: 0,
      isInternal: true,
      haveCommission: false,
      subArea: {
        id: 1,
        name: 'Turbo',
        executionOrder: 1,
      },
      manufacturer: { id: 1, name: 'Han Lue' },
      supplier: { id: 1, name: 'Roman Pearce' },
      isPaintedPart: false,
      tag: {
        id: 1,
        color: 'Azul',
        name: 'ULTRACAR',
        company: { id: 1, name: 'ULTRACAR' },
      },
      status: {
        situation: WorkOrderItemStatus.Green,
        done: 1,
        consolidation: 1,
        reserved: 1,
        remaining: 1,
        quoted: 1,
        purchased: 1,
      },
      origin: WorkOrderItemOrigin.Stock,
      change: 0,
      repair: 0,
      paint: 0,
    },
  ],
  totalDiscountPartPercent: 0,
  totalDiscountServicePercent: 0,
};

export default workorderItems;
